'use strict';

define(['text!edge/quoteandbind/mfp/views/mfp-uw-issues.html', 'angular', 'moment'], function (uwIssueTemplate, angular, moment) {
    return function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext, EventHub) {
        var translateFn = TranslateService.instant;

        var ACTION_MSGS = {
            saveSubmission: function saveSubmission(response) {
                // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                //response.extraArgs is decoration from FlowModel platform code
                var isRetriable = response && response.extraArgs && response.extraArgs.error && response.extraArgs.error[0] && response.extraArgs.error[0].isRetriable;
                return {
                    error: {
                        get title() {
                            return isRetriable ? 'platform.basler.DefaultErrorHandlerService.Retriable Error' : 'quoteandbind.common.config.FlowConfig.Unable to save submission';
                        },
                        get message() {
                            return isRetriable ? 'platform.basler.DefaultErrorHandlerService.Retriable Error.Please retry' : 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.';
                        }
                    },
                    progress: {
                        message: ''
                    }
                };
            }
        };

        var _createSubmission = function _createSubmission(submissionVm) {
            var promise = null;
            if (!submissionVm.value.quoteID) {
                // Initial creation of the submission with default S M and L versions
                promise = LoadSaveService.createSubmission('quoteandbind', submissionVm.value);
            } else {
                // Save changes and requote
                promise = LoadSaveService.saveAndQuoteSubmission('quoteandbind', submissionVm.value);
            }
            return promise.then(function (submissionDTO) {
                return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
            });
        };

        var _quoteSubmission = function _quoteSubmission(submissionVm) {
            var promise = LoadSaveService.saveAndQuoteSubmission('quoteandbind', submissionVm.value);
            return promise.then(function (submissionDTO) {

                var resultSubmissionVm = void 0;

                // Check for controlled uWIssues
                if (!submissionDTO.uWIssues || submissionDTO.uWIssues.length === 0) {
                    //use response to return data
                    resultSubmissionVm = ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
                } else {
                    //if uwissues present, ignore submissionDTO response and return inputDTO with uw issues
                    resultSubmissionVm = ViewModelService.create(submissionVm.value, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
                    resultSubmissionVm.value.uWIssues = submissionDTO.uWIssues;
                }

                return resultSubmissionVm;
            });
        };

        var _saveQuotedSubmission = function _saveQuotedSubmission(submissionVm) {
            var promise = LoadSaveService.saveQuotedSubmission('quoteandbind', submissionVm.value);
            return promise.then(function (submissionDTO) {
                return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
            });
        };

        var _editQuotedSubmissionAndRequote = function _editQuotedSubmissionAndRequote(submissionVm) {
            // 'proof of insurance questions' have to be saved (if exist) before calling the backend, and reinjected in the reponse, as those questions
            // are not persisted in the backend and, therefore, it won't come as part of the response from the backend
            var proofOfInsurance = void 0;
            var language = void 0;
            if (submissionVm.value.bindData) {
                proofOfInsurance = angular.copy(submissionVm.value.bindData.proofOfInsuranceQuestions);
                language = submissionVm.value.bindData.language;
            }

            var promise = LoadSaveService.editQuotedSubmissionAndRequote('quoteandbind', submissionVm.value);
            return promise.then(function (submissionDTO) {

                var resultSubmissionVm = void 0;
                // Check for controlled uWIssues
                if (!submissionDTO.uWIssues || submissionDTO.uWIssues.length === 0) {
                    //restore non-persistent proofOfInsurance questions/answers
                    submissionDTO.bindData.proofOfInsuranceQuestions = proofOfInsurance;
                    submissionDTO.bindData.language = language;
                    resultSubmissionVm = ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
                } else {
                    //if uwissues present, ignore submissionDTO response and return inputDTO with uw issues
                    resultSubmissionVm = ViewModelService.create(submissionVm.value, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
                    resultSubmissionVm.value.uWIssues = submissionDTO.uWIssues;
                }

                return resultSubmissionVm;
            });
        };

        var _bindSubmission = function _bindSubmission(submissionVm) {
            var promise = LoadSaveService.bindSubmission('quoteandbind', submissionVm.value);
            return promise.then(function (submissionDTO) {
                return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelContext);
            });
        };

        var ACTIONS = {
            createSubmission: function createSubmission(submissionVm) {
                return _createSubmission(submissionVm);
            },
            quoteSubmission: function quoteSubmission(submissionVm) {
                return _quoteSubmission(submissionVm);
            },
            saveQuotedSubmission: function saveQuotedSubmission(submissionVm) {
                return _saveQuotedSubmission(submissionVm);
            },
            editQuotedSubmissionAndRequote: function editQuotedSubmissionAndRequote(submissionVm) {
                return _editQuotedSubmissionAndRequote(submissionVm);
            },
            bindSubmission: function bindSubmission(submissionVm) {
                return _bindSubmission(submissionVm);
            }
        };

        //NOTE: fn is similar to BaslerService.isNotExpiredQuote(...), however it checks only 14days in the past condition
        function isNotExpiredQuote(periodStartDate) {
            var lastPossibleDate = moment(new Date()).add('day', -14);
            var periodStartDateMoment = moment(periodStartDate);

            return periodStartDateMoment.isAfter(lastPossibleDate, 'day') || periodStartDateMoment.isSame(lastPossibleDate, 'day');
        }

        return {
            mfpFlow: function mfpFlow(step, junction) {

                step('mfpRiskRelevantData', true).label(function () {
                    return translateFn('quoteandbind.wizard.step.RelevantData_Ext');
                }).onNext.doAction(ACTIONS.createSubmission, ACTION_MSGS.saveSubmission).thenBranch(function (_ref) {
                    var submission = _ref.value;

                    if (submission.quoteData) {
                        // Submission has already been saved and requoted -> go to quote screen
                        return submission.uWIssues && submission.uWIssues.length > 0 ? 'mfpRiskRelevantData' : 'mfpQuoteDetails';
                    } else {
                        // Save and quote submission
                        return 'submissionSaved';
                    }
                }, function (error) {
                    // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                    if (error && error[0] && error[0].isRetriable) {
                        return 'mfpRiskRelevantData';
                    }
                    return 'contactUs';
                }).skipOnResumeIf(function (_ref2) {
                    var submission = _ref2.value;

                    var offersExist = submission.quoteData && submission.quoteData.offeredQuotes.length > 0;
                    var isBound = submission.bindData && submission.bindData.isBound;
                    var pniCitySet = submission.draftData.accountHolder.contact.primaryAddress.city != null;
                    var driverCitySet = submission.draftData.lobs.mFPLine.driverCitySet(submission);

                    //complex condition:
                    //1.if policy bound - move forward (look next conditions in next states)
                    //2.if quotes exist & policy start day is less then 14days in the past - move forward
                    //3.if city of PNI is set - move forward (city could be empty in aggregator cases where plz-city is not unique)
                    //4.if there is a different main driver -> check if the city is set - move forward
                    //else remain on the RiskData page to fix period start date
                    return isBound || offersExist && isNotExpiredQuote(submission.draftData.periodStartDate) && pniCitySet && driverCitySet;
                });

                junction('submissionSaved').onNext.doAction(ACTIONS.quoteSubmission, ACTION_MSGS.saveSubmission).thenBranch(function (_ref3) {
                    var submission = _ref3.value;

                    return submission.uWIssues && submission.uWIssues.length > 0 ? 'mfpRiskRelevantData' : 'mfpQuoteDetails';
                }, function (error) {
                    // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                    if (error && error[0] && error[0].isRetriable) {
                        return 'mfpRiskRelevantData';
                    }
                    return 'contactUs';
                });

                step('mfpQuoteDetails').label(function () {
                    return translateFn('quoteandbind.wizard.step.Quote_Ext');
                }).onNext.doAction(ACTIONS.saveQuotedSubmission, ACTION_MSGS.saveSubmission).thenBranch(function (_ref4) {
                    var submission = _ref4.value;

                    return 'mfpPersonificationQualification';
                }, function (error) {
                    // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                    if (error && error[0] && error[0].isRetriable) {
                        return 'mfpQuoteDetails';
                    }
                    return 'contactUs';
                }).skipOnResumeIf(
                //if policy bound - move forward (to the very last page)
                function (_ref5) {
                    var submission = _ref5.value;
                    return submission.bindData && submission.bindData.isBound;
                });

                step('mfpPersonificationQualification').label(function () {
                    return translateFn('quoteandbind.wizard.step.PersonificationQualification_Ext');
                }).onNext.doAction(ACTIONS.editQuotedSubmissionAndRequote, ACTION_MSGS.saveSubmission).thenBranch(function (_ref6) {
                    var submission = _ref6.value;

                    return submission.uWIssues && submission.uWIssues.length > 0 ? 'mfpPersonificationQualification' : 'mfpSummary';
                }, function (error) {
                    // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                    if (error && error[0] && error[0].isRetriable) {
                        return 'mfpPersonificationQualification';
                    }
                    return 'contactUs';
                }).skipOnResumeIf(
                //if policy bound - move forward (to the very last page)
                function (_ref7) {
                    var submission = _ref7.value;
                    return submission.bindData && submission.bindData.isBound;
                });

                step('mfpSummary').label(function () {
                    return translateFn('quoteandbind.wizard.step.Summary_Ext');
                }).onNext.doAction(ACTIONS.editQuotedSubmissionAndRequote, ACTION_MSGS.saveSubmission).thenBranch(function (_ref8) {
                    var submission = _ref8.value;

                    return submission.uWIssues && submission.uWIssues.length > 0 ? 'mfpSummary' : 'submissionEditedAndRequote';
                }, function (error) {
                    // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                    if (error && error[0] && error[0].isRetriable) {
                        return 'mfpSummary';
                    }
                    return 'contactUs';
                }).skipOnResumeIf(
                //if policy bound - move forward (to the very last page)
                function (_ref9) {
                    var submission = _ref9.value;
                    return submission.bindData && submission.bindData.isBound;
                });

                junction('submissionEditedAndRequote').onNext.doAction(ACTIONS.bindSubmission, ACTION_MSGS.saveSubmission).thenBranch(function (_ref10) {
                    var submission = _ref10.value;

                    return 'mfpConfirmation';
                }, function (error) {
                    // on error from backend, LoadSaveService returns error array: error[0] is exception, error[1] and error[2] empty
                    if (error && error[0] && error[0].isRetriable) {
                        return 'mfpSummary';
                    }
                    return 'contactUs';
                });

                step('mfpConfirmation').label(function () {
                    return translateFn('quoteandbind.wizard.step.Summary_Ext');
                }).onNext.goTo('mfpConfirmationExit'); // B028003 mfpConfirmation should not be the last step, or the model won't be set !

                junction('mfpConfirmationExit'); //exit point

                step('mfpContactUs'); // not used yet
            }
        };
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=mfp!../common/js/src/edge/quoteandbind/mfp/config/FlowConfig.js
// module id = 668
// module chunks = 0